/* ============================================================
   SIMOVO Journal index — search + "Load more" (append)
   Search: as you type, query Shopify's predictive-search API across ALL
   articles (not just the loaded page) and render the matches in place.
   The Search button still submits to /search for the full results page.
   Load more: fetches the next page and APPENDS its cards (keeps the rest).
   ============================================================ */
(function () {
  "use strict";

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }

  function card(a) {
    var img = a.image || a.featured_image || "";
    var imgHtml = img
      ? '<div style="position:relative;aspect-ratio:16/10;overflow:hidden;background:#e8ddcb"><img src="' + esc(img) + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover"></div>'
      : "";
    var exc = (a.summary_html || a.summary || "").replace(/<[^>]+>/g, "").trim();
    if (exc.length > 130) exc = exc.slice(0, 130).replace(/\s+\S*$/, "") + "\u2026";
    return '<a href="' + esc(a.url) + '" class="svo-jrnl-card" style="display:flex;flex-direction:column;background:#fffdf9;border:1px solid #ece0cf;border-radius:20px;overflow:hidden">' +
      imgHtml +
      '<div style="padding:18px 20px 20px;display:flex;flex-direction:column;gap:10px">' +
      '<h3 style="margin:0;font:700 19px/1.25 \'Inter\',system-ui,sans-serif;color:#1c1a17;letter-spacing:-.015em">' + esc(a.title) + '</h3>' +
      (exc ? '<p style="margin:0;font:400 14px/1.5 \'Inter\',system-ui,sans-serif;color:#7c7367">' + esc(exc) + '</p>' : "") +
      '</div></a>';
  }

  function init(root) {
    if (!root || root.__svoJrnl) return;
    root.__svoJrnl = true;

    var input = root.querySelector("[data-svo-search-input]");
    var grid = root.querySelector("[data-svo-grid]");
    var featured = root.querySelector("[data-svo-featured]");
    var empty = root.querySelector("[data-svo-grid-empty]");
    var emptyQ = root.querySelector("[data-svo-grid-empty-q]");
    var clearBtn = root.querySelector("[data-svo-clear]");
    var moreBtn = root.querySelector("[data-svo-loadmore]");
    var origGrid = grid ? grid.innerHTML : "";
    var token = 0;

    function restore() {
      token++;
      if (grid) grid.innerHTML = origGrid;
      if (featured) featured.style.display = "";
      if (empty) empty.hidden = true;
      if (moreBtn) moreBtn.style.display = "";
    }

    function renderResults(articles, q) {
      if (featured) featured.style.display = "none";
      if (moreBtn) moreBtn.style.display = "none";          // pagination is for browsing, not results
      if (!articles.length) {
        if (grid) grid.innerHTML = "";
        if (empty) { empty.hidden = false; if (emptyQ) emptyQ.textContent = q; }
        return;
      }
      if (empty) empty.hidden = true;
      if (grid) grid.innerHTML = articles.map(card).join("");
    }

    function search(q) {
      var mine = ++token;
      var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=article&resources[limit]=10&resources[options][unavailable_products]=last";
      fetch(url, { headers: { "Accept": "application/json" }, credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (mine !== token) return;                        // a newer query superseded this one
          var arts = (data && data.resources && data.resources.results && data.resources.results.articles) || [];
          renderResults(arts, q);
        })
        .catch(function () { /* leave the page intact; the Search button still works */ });
    }

    if (input) {
      var t = null;
      input.addEventListener("input", function () {
        clearTimeout(t);
        var q = (input.value || "").trim();
        if (q.length < 2) { restore(); return; }
        t = setTimeout(function () { search(q); }, 220);
      });
    }
    if (clearBtn) clearBtn.addEventListener("click", function () { if (input) { input.value = ""; restore(); input.focus(); } });

    /* ---- Load more (append) ---- */
    if (moreBtn) {
      moreBtn.addEventListener("click", function (e) {
        var u = moreBtn.getAttribute("href");
        if (!u || moreBtn.getAttribute("data-loading")) return;
        e.preventDefault();
        moreBtn.setAttribute("data-loading", "1");
        var label = moreBtn.textContent; moreBtn.textContent = "Loading\u2026";
        fetch(u, { headers: { "X-Requested-With": "fetch" }, credentials: "same-origin" })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var ng = doc.querySelector("[data-svo-grid]");
            var nb = doc.querySelector("[data-svo-loadmore]");
            if (ng && grid) { Array.prototype.forEach.call(ng.children, function (c) { grid.appendChild(document.importNode(c, true)); }); }
            moreBtn.textContent = label; moreBtn.removeAttribute("data-loading");
            if (nb && nb.getAttribute("href")) { moreBtn.setAttribute("href", nb.getAttribute("href")); }
            else if (moreBtn.parentNode) { moreBtn.parentNode.removeChild(moreBtn); }
            origGrid = grid ? grid.innerHTML : origGrid;     // remember the expanded set
          })
          .catch(function () { window.location.href = u; });
      });
    }
  }

  function boot() { document.querySelectorAll(".svo-jrnl[data-svo-root]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector ? e.target.querySelector(".svo-jrnl[data-svo-root]") : null;
    if (r) { r.__svoJrnl = false; init(r); }
  });
})();